module.exports = __webpack_public_path__ + "img/industry-report.2011a91b.png";